import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { UserPointWalletRepository } from './domain/UserPointWalletRepository'

import { AxiosErrorHandler, SolarResponse } from '../../foundation'

export class UserApiPointWallet implements UserPointWalletRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getBalance = async (): Promise<number> => {
    const config: AxiosRequestConfig = {
      url: '/rewards/user/me/loyalty-wallet/balance',
      method: 'get',
    }

    try {
      const { data } = await this.axios.request<SolarResponse<{ balance: number }>>(config)
      return data.data.balance
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  postPromotionPoint(): Promise<void> {
    const config: AxiosRequestConfig = {
      url: '/rewards/user/me/loyalty-wallet/rewards/send/waiting-list-sign-up',
      method: 'post',
    }

    return this.axios.request(config)
  }
}
